import { useTheme } from '../context/ThemeContext';
import {
  MapPin,
  Briefcase,
  BarChart3,
  Car,
  Navigation,
  FileSpreadsheet,
  Cloud,
  Moon,
  Siren,
  Users,
} from 'lucide-react';

// Update this array as more screenshots are added
const SCREENSHOTS = [8, 3, 2, 4, 5, 6, 7];

const features = [
  { icon: Navigation,     title: 'Automatic GPS Tracking', description: 'Background tracking that just works.'                          },
  { icon: Briefcase,      title: 'Business & Private',     description: 'Categorize trips with one tap.'                                },
  { icon: BarChart3,      title: 'Analytics Dashboard',    description: 'Visual insights into your travel.'                             },

  { icon: MapPin,         title: 'Saved Locations',        description: 'Quick access to frequent places.'                              },

  { icon: FileSpreadsheet,title: 'PDF Export',           description: 'Download reports instantly.'                                   },

 

];

const Features = () => { 
  const theme = useTheme();

  return (
    <section
      id="features"
      className="py-32"
      style={{ backgroundColor: theme.background }}
    >
      <div className="container-app">

        {/* Header */}
        <div className="text-center mb-24">
          <h2
            className="text-responsive-lg font-bold tracking-tight mb-6"
            style={{ color: theme.text }}
          >
            Powerful features.{' '}
            <span className="gradient-text">Zero effort.</span>
          </h2>
          <p
            className="text-xl max-w-xl mx-auto"
            style={{ color: theme.textSecondary }}
          >
            Everything you need to track every kilometer.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-x-8 gap-y-16 mb-32">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="relative inline-block mb-4">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center bg-gradient-brand"
                  style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)' }}
                >
                  <feature.icon className="w-7 h-7 text-white" />
                </div>
              </div>
              <h3
                className="text-base font-semibold mb-1"
                style={{ color: theme.text }}
              >
                {feature.title}
              </h3>
              <p
                className="text-sm"
                style={{ color: theme.textMuted }}
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Screenshot gallery - uses available screenshots only */}
        <div className="relative">
          <div className="flex gap-4 overflow-x-auto pb-4 px-4 snap-x snap-mandatory scrollbar-hide md:scrollbar-styled">
            {SCREENSHOTS.map((num) => (
              <div
                key={num}
                className="flex-shrink-0 w-44 md:w-52 lg:w-56 rounded-3xl overflow-hidden shadow-2xl snap-center hover:scale-105 transition-transform duration-300"
                style={{ border: `1px solid ${theme.border}` }}
              >
                <img
                  src={`/screenshots/${num}.png`}
                  alt={`TripData screenshot ${num}`}
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* Swipe hint - mobile only */}
          <p
            className="text-center text-sm mt-6 md:hidden"
            style={{ color: theme.textMuted }}
          >
            Swipe to see more
          </p>
        </div>

      </div>
    </section>
  );
};

export default Features;